import { useEffect } from "react";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

//import scss
import "./tournament-promotion-event-details.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  clearTournamentNotifications,
  createPromotion,
  saveTournament,
  saveTournamentPromotions,
  selectCurrentTournament,
  selectTournamentNotifications,
  setCurrentTournament,
  setCurrentTournamentPromotion,
} from "../../../reducers/tournamentSlice";
import { getRegistrationEventDetailsForm } from "../../../forms/PromotionForm";
import {
  useFormDataValidation,
  useImageSelector,
} from "../../../hooks/formHooks";
import {
  getSaveBannerActions,
  useNotificationBanner,
} from "../../../hooks/notificationHooks";
import {
  selectCroppedImage,
  setCroppedImage,
} from "../../../reducers/utilitySlice";

//Name the component
const TournamentPromotionEventDetails = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentTournament = useSelector(selectCurrentTournament);
  const croppedImage = useSelector(selectCroppedImage);
  const tournamentNotifications = useSelector(selectTournamentNotifications);

  const heroBannerPhoto = croppedImage?.heroBannerPhoto;
  const promotionalPhoto = croppedImage?.promotionalPhoto;

  const [context, isValid, setIsValid] = useFormDataValidation({
    initialValid: true,
    data: currentTournament?.tournamentPromotion ?? {},
    setData: setCurrentTournamentPromotion,
  });

  const [, , setLogo, removeLogo, getLogo, ,] = useImageSelector(
    context,
    "heroBannerPhoto",
  );

  const [
    ,
    ,
    setPromotionalPhoto,
    removePromotionalPhoto,
    getPromotionalPhoto,
    ,
  ] = useImageSelector(context, "promotionalPhoto");

  const setImage = (files) => {
    const file = files[0];
    const fr = new FileReader(file);
    fr.onload = (e) => {
      if (e) {
        dispatch(
          setCroppedImage({
            ...croppedImage,
            heroBannerPhoto: e.currentTarget.result,
          }),
        );
      }
    };
    fr.readAsDataURL(file);
  };

  const setPromotionalImage = (files) => {
    const file = files[0];
    const fr = new FileReader(file);
    fr.onload = (e) => {
      if (e) {
        dispatch(
          setCroppedImage({
            ...croppedImage,
            promotionalPhoto: e.currentTarget.result,
          }),
        );
      }
    };
    fr.readAsDataURL(file);
  };

  useEffect(() => {
    dispatch(clearTournamentNotifications());
    return dispatch(clearTournamentNotifications());
  }, [dispatch]);

  context.updateTournamentPromotion = (value, property) => {
    setIsValid(true);
    let updateTournament = { ...currentTournament };
    let updateTournamentPromotion = {
      ...currentTournament.tournamentPromotion,
    };
    updateTournamentPromotion[property] = value;
    updateTournament.tournamentPromotion = updateTournamentPromotion;
    dispatch(setCurrentTournament(updateTournament));
  };

  context.updateTournament = (value, property) => {
    setIsValid(true);
    let update = { ...currentTournament };
    update[property] = value;
    dispatch(setCurrentTournament(update));
  };

  context.setVideo = (files, property) => {
    if (files.length === 0) {
      context.updateTournamentPromotion(undefined, property);
      return;
    }
    const file = files[0];
    if (file) {
      const reader = new FileReader();

      reader.addEventListener("load", () => {
        context.updateTournamentPromotion(reader.result, property);
      });

      reader.readAsDataURL(file);
    }
  };

  context.setIsValid = (value) => {
    setIsValid(value);
  };

  context.editImage = () => {
    navigate(`./banner-image/edit/image`);
  };

  context.editPromotionalPhoto = () => {
    navigate(`./promotional-image/edit/image`);
  };

  context.getVideo = (property) => {
    if (
      currentTournament.tournamentPromotion?.[property] &&
      currentTournament.tournamentPromotion?.[property] !==
        "/logos/default/missing.png"
    ) {
      return [
        {
          url: currentTournament.tournamentPromotion?.[property],
          type: "video/mp4",
        },
      ];
    }
    return [];
  };

  context.getLogo = getLogo;
  context.removeLogo = removeLogo;
  context.setLogo = (files) => {
    setImage(files);
    setLogo(files);
  };

  context.getPromotionalPhoto = getPromotionalPhoto;
  context.removePromotionalPhoto = removePromotionalPhoto;
  context.setPromotionalPhoto = (files) => {
    setPromotionalImage(files);
    setPromotionalPhoto(files);
  };

  context.getBannerImageOverlayStyle = () => {
    const style =
      currentTournament?.tournamentPromotion?.bannerImageOverlayStyle ||
      "medium";
    return { value: style };
  };

  context.setBannerImageOverlayStyle = (option) => {
    context.updateTournamentPromotion(option.value, "bannerImageOverlayStyle");
  };

  const save = () => {
    setUnsaved(false);
    setIsValid(false);

    let promotion = {
      ...currentTournament.tournamentPromotion,
      tournament: currentTournament,
      heroBannerPhoto:
        heroBannerPhoto ??
        currentTournament?.tournamentPromotion?.heroBannerPhoto,
      promotionalPhoto:
        promotionalPhoto ??
        currentTournament?.tournamentPromotion?.promotionalPhoto,
    };

    if (currentTournament?.tournamentPromotion?.id) {
      dispatch(saveTournamentPromotions(promotion)).then?.(() => {
        dispatch(saveTournament(currentTournament));
      });
    } else {
      dispatch(createPromotion(promotion));
    }
  };

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Save",
        isDisabled: !isValid,
        action: save,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const leftNavigation = () => {
    if (isValid && !bannerNotifications) {
      setUnsaved(true);
      return;
    }
    timeoutAction();
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Event Site Homepage`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle="Event Site Homepage"
        formSections={getRegistrationEventDetailsForm(
          context,
          currentTournament,
        )}
      ></GSForm>
    );
  };

  const timeoutAction = () => {
    dispatch(clearTournamentNotifications());
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  let notificationSettings = {
    notifications: tournamentNotifications,
    saveAction: save,
    bannerActions: getSaveBannerActions(save, leftNavigation),
    timeoutAction,
  };

  const [bannerNotifications, setUnsaved] = useNotificationBanner(
    notificationSettings,
  );

  return (
    //name the component tag
    <tournament-promotion-event-details>
      <GSSidePanelPage
        header={getNavigation()}
        banner={bannerNotifications}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </tournament-promotion-event-details>
  );
};

//export the new name
export default TournamentPromotionEventDetails;
